import { AreaSchedule } from './AreaSchedule'
import { DiaryNote } from '@app/domain/DiaryNote'
import { VenueClosure } from './VenueClosure'
import { BookingSlotVelocityLimitOverride } from './BookingSlotVelocityLimitOverride'

export class VenueSchedule {

    constructor(
        public diaryNotes: DiaryNote[],
        public areas: AreaSchedule[],
        public bookingSlotVelocityLimitOverrides: BookingSlotVelocityLimitOverride[]
    ) { }

    diaryNotesOccurringOnDate(date: Date): DiaryNote[] {
        return this.diaryNotes
            .filter(note => note.occursOnDate(date))
    }

    venueActivitiesOccurringOnDate(date: Date): DiaryNote[] {
        return this.diaryNotes
            .filter(note => note.startTime !== null)
            .filter(note => note.occursOnDate(date))
    }

    bookingSlotVelocityLimitOverridesOccurringOnDate(date: Date): BookingSlotVelocityLimitOverride[] {
        return this.bookingSlotVelocityLimitOverrides
            .filter(override => override.occursOnDate(date))
    }

    allClosures(): VenueClosure[] {
        return this.areas.map(areaSchedule => areaSchedule.closures).flat()
    }

    addClosure(closure: VenueClosure) {
        if (this.areas.length === 0) {
            return
        }
        this.removeClosure(closure.id)
        if (closure.appliesToEntireVenue) {
            this.areas.forEach(area => area.closures.push(closure))
        } else {
            const area = this.areas.find(area => area.area.getTableWithId(closure.tableIds[0]))
            if (area) {
                area.closures.push(closure)
            }
        }
    }

    removeClosure(closureId: string): void {
        this.areas.forEach(area => {
            const index = area.closures.findIndex(c => c.id === closureId)
            if (index !== -1) {
                area.closures.splice(index, 1)
            }
        })
    }
}
